import { render, staticRenderFns } from "./SkeletonPetCards.vue?vue&type=template&id=6b596228&scoped=true&"
import script from "./SkeletonPetCards.vue?vue&type=script&lang=js&"
export * from "./SkeletonPetCards.vue?vue&type=script&lang=js&"
import style0 from "./SkeletonPetCards.vue?vue&type=style&index=0&id=6b596228&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b596228",
  null
  
)

export default component.exports